import { render, staticRenderFns } from "./AutoDesformDataFullScreen.vue?vue&type=template&id=6c935bb1&scoped=true&"
import script from "./AutoDesformDataFullScreen.vue?vue&type=script&lang=js&"
export * from "./AutoDesformDataFullScreen.vue?vue&type=script&lang=js&"
import style0 from "./AutoDesformDataFullScreen.vue?vue&type=style&index=0&id=6c935bb1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c935bb1",
  null
  
)

export default component.exports